import { ButtonMain } from '@/modules/common/components/button';
import styles from './index.module.sass';
import { useEffect, useState } from 'react';
import arrowIcon from '@@/offer/images/arrow.svg';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'effector-react';
import {
  $selectedOffers,
  setSelectedOffers as setSelectedOffersIds,
} from '../../store/offer-page.store';
import { declineWord } from '@/modules/common/helpers/decline-word.helper';
import { $tradeOffers } from '../../store/business-offers.store';
import { IIncomingOffer } from '../../types/business-offer';
import { multiApproveBusinessOffers } from '../../functions/multi-approve.function';
import { getRemainingMinutes } from '@/modules/common/helpers/compare-date.helper';
import { notification } from 'antd';
import {
  TRADE_OFFER_NOT_ACTUAL_OFFSET_BEFORE_EXPIRATION_MINUTES,
  TRADE_OFFER_PRE_EXPIRATION_MINUTES,
} from '@/modules/common/constants/trade-offers.constant';
import { WITHOUT_VAT } from '@/shared/constants/price.constants';

export const OfferSidebar = () => {
  const tradeOffers = useStore($tradeOffers);
  const expirationOffset = TRADE_OFFER_NOT_ACTUAL_OFFSET_BEFORE_EXPIRATION_MINUTES;
  const preExpirationOffset = TRADE_OFFER_PRE_EXPIRATION_MINUTES;

  const selectedOffersIds = useStore($selectedOffers);
  const [expiredOffersDynamic, setExpiredOffersDinamic] = useState<number[]>([]);
  const [expanded, setExpanded] = useState(true);
  const navigate = useNavigate();
  const [selectedOffers, setSelectedOffers] = useState(
    tradeOffers.filter((item) => selectedOffersIds.includes(item.id)),
  );

  const recalculateMetrics = (tradeOffers: IIncomingOffer[]) => ({
    totalWeight: tradeOffers
      .filter(
        (item) =>
          getRemainingMinutes(`${item.expiration_date} UTC`) >= expirationOffset &&
          selectedOffersIds.includes(item.id),
      )
      .reduce(
        (prev, current) => prev + (+current.weight + +current.weight_gain_tons),
        0,
      ),
    totalFreight: tradeOffers
      .filter(
        (item) =>
          getRemainingMinutes(`${item.expiration_date} UTC`) >= expirationOffset &&
          selectedOffersIds.includes(item.id),
      )
      .reduce((prev, current) => prev + +current.price_logistic, 0),
    totalPrice: tradeOffers
      .filter(
        (item) =>
          getRemainingMinutes(`${item.expiration_date} UTC`) >= expirationOffset &&
          selectedOffersIds.includes(item.id),
      )
      .reduce((prev, current) => prev + +current.price_all, 0),
  });

  const [metrics, setMetrics] = useState(recalculateMetrics(tradeOffers));

  useEffect(() => {
    const state = recalculateMetrics(tradeOffers);
    setMetrics(state);
    const interval = setInterval(() => {
      const expiredOffers = tradeOffers.filter(
        (item) => getRemainingMinutes(`${item.expiration_date} UTC`) < expirationOffset,
      );
      setExpiredOffersDinamic(expiredOffers.map((item) => item.id));
      const state = tradeOffers && recalculateMetrics(tradeOffers);
      tradeOffers && setMetrics(state);
    }, 3000);
    return () => clearInterval(interval);
  }, [tradeOffers, selectedOffersIds, selectedOffersIds]);

  useEffect(() => {
    const selectedOffersData = tradeOffers.filter((item) =>
      selectedOffersIds.includes(item.id),
    );
    setSelectedOffers(selectedOffersData);
  }, [tradeOffers, selectedOffersIds]);

  // useEffect(() => {
  //   const selectedOffersData = tradeOffers.filter((item) =>
  //     selectedOffersIds.includes(item.id),
  //   );
  //   setMetrics({
  //     totalWeight: selectedOffersData
  //       .filter((item) => getRemainingMinutes(item.expiration_date) >= 5)
  //       .reduce((prev, current) => prev + +current.weight, 0),
  //     totalFreight: selectedOffersData
  //       .filter((item) => getRemainingMinutes(item.expiration_date) >= 5)
  //       .reduce((prev, current) => prev + +current.price_logistic, 0),
  //     totalPrice: selectedOffersData
  //       .filter((item) => getRemainingMinutes(item.expiration_date) >= 5)
  //       .reduce((prev, current) => prev + +current.total, 0),
  //   });
  // }, [selectedOffersIds, tradeOffers, selectedOffers]);

  return (
    <div className={styles.root}>
      <ButtonMain
        className={styles.approve}
        label="оформить выбранные сделки"
        active={selectedOffersIds.length > 0}
        onClick={async () => {
          if (selectedOffersIds.length > 0) {
            const validOffers = selectedOffers.filter(
              (item) =>
                getRemainingMinutes(`${item.expiration_date} UTC`) > expirationOffset &&
                selectedOffersIds.includes(item.id),
            );
            if (validOffers.length < 1)
              return notification.error({
                message: 'Отсутствуют актуальные сделки к оформлению',
              });
            await multiApproveBusinessOffers(validOffers.map((item) => item.id));
            setSelectedOffersIds([]);
            navigate('/offer/contracts');
          }
        }}
      />
      <div className={styles.mainArea} onClick={() => setExpanded(!expanded)}>
        <div className={styles.visibleArea}>
          <span>
            {declineWord(selectedOffers.length, ['сделок', 'сделка', 'сделки'])}
            {expiredOffersDynamic.filter((item) => selectedOffersIds.includes(item))
              .length > 0 && (
              <span>
                {'  '}(
                {declineWord(
                  expiredOffersDynamic.filter((item) =>
                    selectedOffersIds.includes(item),
                  ).length,
                  ['не актуальных', 'не актуальная', 'не актуальные'],
                )}
                )
              </span>
            )}
          </span>
          <span className={styles.button}>
            {expanded ? 'свернуть' : 'развернуть'}{' '}
            <img
              src={arrowIcon}
              style={{ transform: `rotate(${expanded ? '180' : '0'}deg)` }}
              className={styles.arrowIcon}
            />
          </span>
        </div>
        <ul
          className={styles.dynamicList}
          style={{ display: expanded ? 'block' : 'none' }}
        >
          {selectedOffers.map((item) => (
            <ItemAgent
              i={item.id}
              data={item}
              expired={expiredOffersDynamic.includes(item.id)}
            />
          ))}
        </ul>
      </div>
      <span className={styles.comment}>
        * Cделки с истекшим сроком действия не учитываются при итоговых подсчетах и
        игнорируются при оформлении сделок
      </span>
      <div className={styles.requirements}>
        {tradeOffers
          .filter(
            (item) =>
              selectedOffersIds.includes(item.id) &&
              getRemainingMinutes(`${item.expiration_date} UTC`) > expirationOffset,
          )
          .filter((item) => item.action === 'mix').length > 0 && (
          <span className={styles.mixing}>
            {declineWord(
              tradeOffers
                .filter(
                  (item) =>
                    selectedOffersIds.includes(item.id) &&
                    getRemainingMinutes(`${item.expiration_date} UTC`) >
                      expirationOffset,
                )
                .filter((item) => item.action === 'mix').length,
              ['сделок требуют', 'сделка требует', 'сделки требуют', 'сделок требуют'],
            )}{' '}
            миксования
          </span>
        )}
        {tradeOffers
          .filter(
            (item) =>
              selectedOffersIds.includes(item.id) &&
              getRemainingMinutes(`${item.expiration_date} UTC`) > expirationOffset,
          )
          .filter((item) => item.action === 'hydrate').length > 0 && (
          <span className={styles.mixing} style={{ backgroundColor: '#C8E7FF' }}>
            {declineWord(
              tradeOffers
                .filter(
                  (item) =>
                    selectedOffersIds.includes(item.id) &&
                    getRemainingMinutes(`${item.expiration_date} UTC`) >
                      expirationOffset,
                )
                .filter((item) => item.action === 'hydrate').length,
              ['сделок требуют', 'сделка требует', 'сделки требуют', 'сделок требуют'],
            )}{' '}
            увлажнения
          </span>
        )}
        {tradeOffers
          .filter(
            (item) =>
              selectedOffersIds.includes(item.id) &&
              getRemainingMinutes(`${item.expiration_date} UTC`) > expirationOffset,
          )
          .filter((item) => item.action === 'drain').length > 0 && (
          <span className={styles.drain}>
            {declineWord(
              tradeOffers
                .filter(
                  (item) =>
                    selectedOffersIds.includes(item.id) &&
                    getRemainingMinutes(`${item.expiration_date} UTC`) >
                      expirationOffset,
                )
                .filter((item) => item.action === 'drain').length,
              ['сделок требуют', 'сделка требует', 'сделки требуют', 'сделок требуют'],
            )}{' '}
            осушения
          </span>
        )}
      </div>
      <div className={styles.totalInfo}>
        <div className={styles.requisite}>
          <span className={styles.label}>Общий вес используемого зерна</span>
          <span className={styles.val}>
            {metrics.totalWeight?.toLocaleString('ru', { maximumFractionDigits: 1 })} т
          </span>
        </div>
        <div className={styles.requisite}>
          <span className={styles.label}>
            Общая стоимость всего зерна {WITHOUT_VAT}
          </span>
          <span className={styles.val}>
            {metrics.totalPrice?.toLocaleString('ru', { maximumFractionDigits: 0 })} ₽
          </span>
        </div>
        <div className={styles.requisite}>
          <span className={styles.label}>Общая стоимость логистики</span>
          <span className={styles.val}>
            {metrics.totalFreight?.toLocaleString('ru', { maximumFractionDigits: 0 })} ₽
          </span>
        </div>
      </div>
      <div className={styles.overall}>
        <div className={styles.overallInner}>
          <span className={styles.label}>Итого НЕТТО</span>
          <span className={styles.val}>
            {(metrics.totalPrice - metrics.totalFreight).toLocaleString('ru', {
              maximumFractionDigits: 0,
            })}{' '}
            ₽
          </span>
        </div>
        <div className={styles.filler}></div>
      </div>
    </div>
  );
};

function ItemAgent({
  i,
  drain,
  data,
  expired,
}: {
  i: number;
  drain?: boolean;
  data: IIncomingOffer;
  expired: boolean;
}) {
  return (
    <li
      className={styles.item}
      style={expired ? { textDecoration: 'line-through' } : undefined}
    >
      <span className={styles.num}>{data.id}</span>
      <span className={styles.buyer}>{data.company_name}</span>
      <span className={styles.tag}>
        {data.action === 'drain' ? (
          <span className={styles.drain}>осушение</span>
        ) : data.action === 'hydrate' ? (
          <span style={{ backgroundColor: '#C8E7FF' }}>увлажнение</span>
        ) : data.action === 'mix' ? (
          <span>миксование</span>
        ) : (
          ''
        )}
      </span>
      <span className={styles.weight}>
        {(parseFloat(data.weight) + +data.weight_gain_tons).toLocaleString('ru', {
          maximumFractionDigits: 2,
        })}{' '}
        т
      </span>
      <span className={styles.price}>
        {parseFloat(data.price_all).toLocaleString('ru', { maximumFractionDigits: 0 })}{' '}
        ₽
      </span>
    </li>
  );
}
